import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { NAV_LINKS } from '../data/homeData';

function Header() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    document.body.classList.toggle('menu-open', menuOpen);
    return () => document.body.classList.remove('menu-open');
  }, [menuOpen]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [location.pathname]);

  const isActive = (link) => {
    if (link.label === 'Home') return location.pathname === '/';
    if (link.label === 'About Us') return location.pathname === '/about-us' || location.pathname === '/about';
    if (link.label === 'Products') return location.pathname.startsWith('/products');
    if (link.label === 'Contact') return location.pathname === '/contact';
    return false;
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleHomeClick = (event) => {
    setMenuOpen(false);
    if (location.pathname === '/' && !location.hash) {
      event.preventDefault();
      scrollToTop();
    }
  };

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-inner">
        <Link
          to="/"
          className="header-logo"
          aria-label="Swarvinn Impex Ltd — Home"
          onClick={handleHomeClick}
        >
          <img
            src="/images/logo-header.png"
            alt="Swarvinn Foods — Swarvinn Impex logo"
            className="site-logo-img"
          />
          <span className="logo-brand-text">
            <span className="logo-brand-name">Swarvinn</span>
            <span className="logo-brand-sub">Impex Ltd</span>
          </span>
        </Link>

        <nav className={`header-nav ${menuOpen ? 'open' : ''}`}>
          {NAV_LINKS.map((link) => (
            <Link
              key={link.label}
              to={link.href}
              className={`nav-link ${isActive(link) ? 'active' : ''}`}
              onClick={link.label === 'Home' ? handleHomeClick : () => setMenuOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="header-actions">
          <Link to="/contact" className="quote-btn">UK Import Quote</Link>
          <button
            type="button"
            className="menu-toggle"
            aria-label="Menu"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <Menu size={24} />
          </button>
        </div>
      </div>
    </header>
  );
}

export default Header;
